import { View, Text, Dimensions, TouchableOpacity, Image } from "react-native";
import React, { useEffect, useState } from "react";
import Modal from "react-native-modal";
import { useDispatch, useSelector } from "react-redux";
import MyModal from "./MyModal";
import MyInputWithLabel from "../custom/MyInputWithLabel";
import MyText from "../custom/MyText";
import translate from "../../functions/translate";
import MyButton from "../custom/MyButton";
import StepSlide from "../animation/StepSlide";
import { danger, orange, primary } from "../../colors";
import CodeInput from "../custom/CodeInput";
import { noMoney } from "../../imports";
import checkSettings from "../../api/consultation/checkSettings";
import { setCheckSettingsModal } from "../../redux/modal/modalAction";
import { MaterialIcons } from "@expo/vector-icons";

export default function CheckSettingsModal({ visible }) {
  const modal = useSelector((store) => store.modal);
  const dispatch = useDispatch();
  useEffect(() => {
    checkSettings().then(({ data }) => {
      if (data.status !== 200) {
        dispatch(setCheckSettingsModal());
      }
    });
  }, []);
  return (
    <MyModal isVisible={modal.checkSettingsModal}>
      <View
        style={{
          width: "100%",
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        <MaterialIcons name="error-outline" size={120} color={danger} />
        <View style={{ width: "90%", marginBottom: 10, marginTop: 20 }}>
          <MyText style={{ textAlign: "center" }}>
            خطایی در حساب شما وجود دارد لطفاً از طریق پشتیبانی برنامه پیگیری
            نمایید
          </MyText>
        </View>
      </View>
    </MyModal>
  );
}
